import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("webtu_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const siteHtmlUrl = (siteId, opts = {}) => {
  const p = new URLSearchParams();
  if (opts.v !== undefined && opts.v !== null) p.set("v", opts.v);
  if (opts.edit) p.set("edit", "1");
  if (opts.t) p.set("t", opts.t);
  const qs = p.toString();
  return `${API}/sites/${siteId}/html${qs ? `?${qs}` : ""}`;
};
